import { ChevronsLeft } from "lucide-react";
import { useSidebar } from "@/modules/dashboard-shell/SidebarProvider";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { cn } from "@/shared/lib/cn";

/** Double flèche qui pivote selon l'état du menu : vers la gauche pour réduire, vers la droite pour agrandir. */
function SidebarToggleIcon({ isOpen }: { isOpen: boolean }) {
  return (
    <ChevronsLeft
      size={18}
      strokeWidth={2}
      aria-hidden="true"
      className={cn(
        "transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none",
        !isOpen && "rotate-180",
      )}
    />
  );
}

/**
 * Bouton qui réduit ou agrandit le menu latéral.
 * `variant="sidebar"` : posé sur le fond vert sombre du menu ; `variant="header"` : bouton du bandeau (mobile).
 */
export function SidebarToggle({ variant = "sidebar", className }: { variant?: "sidebar" | "header"; className?: string }) {
  const { t } = useTranslation();
  const { isOpen, toggle } = useSidebar();
  const label = isOpen ? t.header.closeSidebar : t.header.menu;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      aria-expanded={isOpen}
      title={label}
      className={cn(
        variant === "header"
          ? "rhythm-icon-btn shrink-0 active:scale-[0.96]"
          : "grid h-9 w-9 shrink-0 place-items-center rounded-xl text-sidebar-muted transition-[background-color,color,transform] duration-150 hover:bg-accent hover:text-accent-foreground active:scale-[0.96] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
        className,
      )}
    >
      <SidebarToggleIcon isOpen={isOpen} />
    </button>
  );
}
